export default __webpack_public_path__ + "static/media/icon.a2d925ad.svg";